export default {"src":"/_next/static/media/icon_footer_store.90ffb4ec.svg","height":35,"width":35,"blurWidth":0,"blurHeight":0};